import React, { useEffect, useState, useContext, useCallback } from 'react';
import rainbowSDK from 'rainbow-web-sdk';
import { Grid, Paper, TextField, Button, Card, CardContent, Snackbar, IconButton, Typography, Backdrop, MenuItem, CircularProgress } from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';
import { jsMessageType, agentStatuses } from './constants.js';
import { Context } from '../Context.js';
import { sendMsgToServer, messageQueue, deleteMsgFromServer, getMsgFromServer } from './helperfunctions.js';
import { AgentState, LoginResponse, GroupCallRinging, AgentGroupInfo, CallDetails, VBoardStatsChanged, VBoardStats } from './objects.js';
import AgentStateCard from './AgentStateCard';
import QueuesDialog from './QueuesDialog';
import UnavailableDialog from './UnavailableDialog';
import MuiAlert from '@material-ui/lab/Alert';
import UnavailableIcon from '@material-ui/icons/RemoveCircle';
import QueueIcon from '@material-ui/icons/FormatListBulleted';
import HandIcon from '@material-ui/icons/PanToolOutlined';
import TimerIcon from '@material-ui/icons/Timer';
import SetOutComes from './SetOutComes.jsx';
import SignOutIcon from '@material-ui/icons/ExitToApp';
// import PersonIcon from '@material-ui/icons/Person';
import CallEndIcon from '@material-ui/icons/CallEnd';
import vurellaLogo from '../images/vlogo.png';
import { useTranslation } from 'react-i18next';
import PersonIcon from '@material-ui/icons/PersonOutline';
import vurellaACD from '../images/118.png';
import VBoard from './VBoard';

var myChannelObject = null;
var LastHeartBeatTime = null;
var myChannelID = '';
var myExtension = '';
var displayExtension = '';
var LoggedInAcdServer = 0;
var LoggedInAcdServerTime = '';
var timerId;
var Current_AgentState = AgentState;
var outComeEnable = false;
var primaryOC = '';
var secondaryOC = '';
var currentCallDetail = CallDetails;
var agentExt;
var hrtBeatReset = 0;
const initialValue = { primaryOutCome: '', secondaryOutCome: '' };
const useStyles = makeStyles((theme) => ({
  root: {
    flexGrow: 1,
    //width: '90%',
    maxHeight: '9vh',
    // marginTop: "0px",
    ' & .MuiCardContent-root': {
      padding: '8px',
    },
    ' & .MuiCardHeader-root': {
      padding: '10px',
    },
  },
  Card_RH: {
    backgroundColor: '#0288d1',
    justifyContent: 'center',
    textAlign: 'center',
  },
  Card_RH_2: {
    backgroundColor: '#0288d1',
    justifyContent: 'center',
    textAlign: 'center',
    // height: "80px",
  },
  Card_Queues: {
    backgroundColor: '#0288d1',
    justifyContent: 'center',
    textAlign: 'center',
  },
  backdrop: {
    zIndex: theme.zIndex.drawer + 1,
    color: '#fff',
  },

  loginACD: {
    position: 'relative',
    display: 'flex',
    height: '90vh',
    justifyContent: 'center',
    //alignItems:'center',
    paddingTop: '12px',

    '& .MuiTextField-root': {
      margin: theme.spacing(1),
      width: '310px',
    },
    '& .MuiButton-root': {
      margin: theme.spacing(1),
      width: '310px',
      height: '48px',
      backgroundColor: '#0288d1',
    },
  },
  Loginpaper: {
    position: 'relative',
    flexGrow: 1,
    padding: theme.spacing(4),
    margin: theme.spacing(4),
    textAlign: 'center',
    justifyContent: 'center',
    color: '#b3e5fc',
    height: 380 + 'px',
  },
  buttonProgress: {
    position: 'absolute',
    top: '50%',
    left: '75%',
    marginTop: -12,
    marginLeft: -12,
    color: 'white',
  },
  container: {
    width: '95%',
    margin: '0 auto',
    padding: '10px',
    maxHeight: '80vh',
    // marginTop: "20px",
  },
}));

///////////////////////// APPLE IOS FUNCTIONS//////////////////////////
function exitFromIOS() {
  let mesg = {
    Type: jsMessageType.LOGOUT,
    Value: '',
    CreationTime: '',
  };
  sendMsgToServer(myChannelObject, mesg);
}

function isIOSDevice() {
  return !!navigator.platform && /iPad|iPhone|iPod/.test(navigator.platform);
}

function sendLogoutToMobile() {
  let myObj = { Message: 'LOGOUT', Username: '', Password: '', Channel: '' };
  let myJson = JSON.stringify(myObj);
  window.webkit.messageHandlers.jsMessageHandler.postMessage(myJson);
}
function sendLoginToMobile(uname, pass, channel) {
  let myObj = {
    Message: 'LOGIN',
    Username: uname,
    Password: pass,
    Channel: channel,
  };
  let myJson = JSON.stringify(myObj);
  window.webkit.messageHandlers.jsMessageHandler.postMessage(myJson);
}
////////////////////////////////////////////////////////////////////////////////

////////////////////////// ANDROID FUNCTIONS///////////////////////////////////

function isAndroidDevice() {
  if (window.vACDInterface) return true;
  else return false;
}

function sendLoginToAndroid(uname, pass, channel) {
  window.vACDInterface.rainbowLogin(uname, pass, channel);
}
function sendLogoutToAndroid() {
  window.vACDInterface.rainbowLogout();
}

var callID = null;

/////////////////////////////////// TELEPHONY EVENT HANDLING////////////////////////////////////
const onTelephonyVoipChangedEvent = function (event) {
  if (event.detail.status.value == 'incommingCall' && event.detail.type.value == 'Phone') {
    // console.log("Incoming Voip Call Fired");
    callID = event.detail;
    //   setTimeout(() => {
    //   rainbowSDK.telephony.answer(callID).then(()=>{});
    // },2000);
  }

  if (event.detail.status.value == 'active' && event.detail.type.value == 'Phone') {
    // console.log("CALL CONNECTED VOIP EVENT FIRED");
    // console.log(event.detail);
  }
};

/////////////////////////////////// TELEPHONY EVENT HANDLING////////////////////////////////////

export default function VurellaACD(props) {
  //console.log("VurellaACD Function Fired");
  const { t } = useTranslation();
  const [userAccount, setUserAccount] = useContext(Context);
  const [agentState, setAgentState] = useState(AgentState);
  const [groupCallRinging, setGroupCallRinging] = useState(GroupCallRinging);
  const [loginResponse, setLoginResponse] = useState(LoginResponse);
  const [agentGroups, setAgentGroups] = useState([AgentGroupInfo]);
  const [callOutCome, setCallOutCome] = useState(initialValue);
  const [raiseHand, setRaiseHand] = useState(false);
  const [openQueueDialog, setOpenQueueDialog] = useState(false);
  const [openUnavailableDialog, setOpenUnavailableDialog] = useState(false);
  const [absenseReasons, setAbsenseReasons] = useState([]);
  const [errorOpen, setErrorOpen] = useState(false);
  const [errorMsg, setErrorMsg] = useState('');
  const [countDown, setCountDown] = useState('00');
  const [circularProgress, setCircularProgress] = useState(false);
  const [backdropOpen, setBackdropOpen] = useState(false);
  const [vboardStats, setVBoardStats] = useState(VBoardStats);

  //ACD LOGIN States
  const [myExt, setMyExtension] = useState(localStorage.getItem('myExt') == null ? 'office' : localStorage.getItem('myExt'));
  const [showExtTB, setShowExtTB] = useState(false);
  const [userN, setUserName] = useState(localStorage.getItem('agentid'));
  const [passW, setPassWord] = useState(localStorage.getItem('agentpassword'));
  const [otherExt, setOtherExt] = useState(localStorage.getItem('otherext'));
  const [btnState, setBtnState] = useState(false);

  //CSS
  const classes = useStyles();

  //////////////////////////////////////////////////////////////////////////////////////////////
  const handleReconnectClose = () => {
    setBackdropOpen(false);
  };

  ////////////////////////////////START COMPONENT LOGIC FUNCTIONS///////////////////////////////
  const onChannelMessageReceived = useCallback((message) => {
    let d = new Date();
    // console.log("CHANNEL MESSAGE RECIEVED EVENT @ " + d.toLocaleString());
    if (myChannelID != null) {
      messageQueue.push(message);
      processMessageQueue();
    }
  }, []);

  const onTelephonyChangedEvent = useCallback((event) => {
    if (event.detail.status.value == 'incommingCall' && event.detail.type.value == 'Phone') {
      // console.log("Incoming Call Fired");
      callID = event.detail;
    }
    if (event.detail.status.value == 'active' && event.detail.type.value == 'Phone') {
      //console.log("CALL CONNECTED EVENT FIRED");
      callID = event.detail;
      // console.log(event.detail);
      setAgentState({ ...agentState, AgentState: agentStatuses.ACD_Busy });
      Current_AgentState.AgentState = agentStatuses.ACD_Busy;
    }
    if (event.detail.status.value == 'Unknown' && event.detail.type.value == 'Phone') {
      callID = null;
      // console.log("Updating Agent State to Disconnected");
    }
  }, []);
  const onConnectionStateChanged = useCallback((myevent) => {
    let status = myevent.detail;
    // console.log("CONNECTION STATE CHANGED TO:" + status);

    if (status === rainbowSDK.connection.RAINBOW_CONNECTIONDISCONNECTED) {
      setBackdropOpen(true);
    } else if (status === rainbowSDK.connection.RAINBOW_CONNECTIONCONNECTED) {
      setBackdropOpen(false);

      var h_mesg = {
        Type: jsMessageType.HRT_BEAT,
        Value: '',
        CreationTime: '',
      };
      sendMsgToServer(myChannelObject, h_mesg);
    }
  }, []);

  //SIGNOUT FROM VURELLA ACD BUT NOT FROM RAINBOW. THIS HAPPENS WHEN USER CLICKS ON LOGOUT BUTTON
  const signOut = useCallback(() => {
    let mesg = {
      Type: jsMessageType.LOGOUT,
      Value: '',
      CreationTime: '',
    };
    sendMsgToServer(myChannelObject, mesg);
    clearTimeout(timerId);
    setUserAccount((userAccount) => ({ ...userAccount, acdloggedin: null }));

    if (isIOSDevice()) sendLogoutToMobile();
    else if (isAndroidDevice()) sendLogoutToAndroid();

    setBackdropOpen(true);
  }, []);
  //SIGNOUT FROM RAINBOW. THIS HAPPENS WHEN USER CLICKS ON VURELLA LOGO ON AGENT LOGIN SCREEN
  const signOutRainbow = () => {
    LoggedInAcdServer = 0;
    clearTimeout(timerId);
    rainbowSDK.connection
      .signout()
      .then(function (res) {
        // console.log("Signed Out from Rainbow");
        setUserAccount((userAccount) => ({
          ...userAccount,
          firstname: '',
          lastname: '',
          extension: '',
          channelobject: null,
          channelid: null,
          rainbowloggedin: false,
          acdloggedin: null,
        }));
        props.onChange(false);
      })
      .catch((err) => {
        setUserAccount((userAccount) => ({
          ...userAccount,
          firstname: '',
          lastname: '',
          extension: '',
          channelobject: null,
          channelid: null,
          rainbowloggedin: false,
          acdloggedin: false,
        }));
        // console.log(err);
      });
  };
  //LOGIN TO VURELLA ACD. THIS IS DONE VIA RAINBOW CHANNEL COMMUNICATION.
  const loginVACD = useCallback((agentid, agentpassword) => {
    //myExtension = myExt;
    if (myExtension !== null) {
      Current_AgentState = AgentState;

      if (LoggedInAcdServer === 0) {
        // console.log("Extension sent to Server is:" + myExtension);
        LoggedInAcdServer = 1; //COULD BE REMOVED. IGNORE IT FOR NOW.
        rainbowSDK.channels
          .fetchChannelsByName('vACD_' + agentid) // CHANNEL IS CREATED BY SERVER. NAME IS ALWAYS vACD_AGENTID (e.g vACD_276)
          .then(function (res) {
            if (res.length > 0) {
              if (res[0].userRole === 'publisher' || res[0].userRole === 'owner') {
                myChannelObject = res[0];
                myChannelID = res[0].id;
                rainbowSDK.channels
                  .subscribeToChannelById(res[0].id)
                  .then((res) => {
                    let mesg = {
                      Type: 'LOGIN_PHONE',
                      Value: {
                        UFID: '',
                        Username: agentid,
                        PhoneExtension: myExtension,
                        Password: agentpassword,
                        IsSuperVisor: 'false',
                      },
                      CreationTime: '',
                    };
                    // console.log("Channel Subscribed"); //IF CHANNEL IS SUBSCRIBED THEN WE CAN SEND LOGIN MESSAGE TO SERVER
                    setUserAccount({
                      ...userAccount,
                      channelobject: myChannelObject,
                      channelid: myChannelID,
                    });
                    setAgentState({
                      ...agentState,
                      Name: userAccount.name,
                      AgentExtension: userAccount.extension,
                    });
                    sendMsgToServer(myChannelObject, mesg);
                    //console.log(mesg);
                  })
                  .catch((err) => {
                    // console.log("Error Subscribing to Channel");
                    LoggedInAcdServer = 0;
                    setUserAccount((userAccount) => ({
                      ...userAccount,
                      acdloggedin: false,
                    }));
                  });
              } else {
                // console.log("Invalid Channel ID");
                setErrorMsg('Invalid AgentID');
                setErrorOpen(true);
                LoggedInAcdServer = 0;
                setBtnState(false);
              }
            } else {
              // console.log("No Channels Found");
              setErrorMsg('Could not log into Vurella ACD Server');
              setErrorOpen(true);
              LoggedInAcdServer = 0;
              setBtnState(false);
            }
          })
          .catch(function (err) {
            // console.log("Error Subscribing to Channel");
            setErrorMsg('Could not log into Vurella ACD Server');
            setErrorOpen(true);
            setBtnState(false);
            LoggedInAcdServer = 0;
            setUserAccount((userAccount) => ({
              ...userAccount,
              acdloggedin: false,
            }));
          });
      }
    }
  }, []);
  const processMessageQueue = useCallback(() => {
    while (messageQueue.length > 0) {
      try {
        var serverResponse = messageQueue[0].detail.entry.message;

        //CHECK IF MESSAGE RECEIVED FROM CHANNEL IS A MESSAGE FROM THE SERVER. IT SHOULD START WITH #SERVER# OTHERWISE IGNORE AND REMOVE FROM QUEUE
        if (serverResponse.search('#SERVER#') == -1) {
          // console.log("No Server Response in Channel");
          messageQueue.shift(); //Empty any AGENT Messages in Queue
          continue;
        }
        //IF MESSAGE IS FROM SERVER THEN PARSE TO CHECK WHAT TYPE OF RESPONSE IT IS.
        else {
          let jsonMessage = JSON.parse(serverResponse.slice(8)); //REMOVE THE #SERVER# PART FROM THE STRING SO JSON CAN BE PARSED
          let d = new Date();

          //FIRST RESPONSE IS ALWAYS LOGIN_RESPONSE. AFTER THAT WE START GETTING OTHER MESSAGES
          if (jsonMessage.Type === jsMessageType.LOGIN_RESPONSE_AGENT) {
            // console.log(
            //   "ACD Login Response " +
            //     jsonMessage.Value.IsSuccess +
            //     " @ " +
            //     d.toLocaleString()
            // );
            if (jsonMessage.Value.IsSuccess === true) {
              //IF SERVER SUCCESS THEN WE CAN START USING AGENT ACD ELSE SHOW ERROR
              window.signOutFunc = exitFromIOS;
              // console.log(
              //   "RainbowUsername:" +
              //     userAccount.rainbowusername +
              //     " RainbowPassowrd:" +
              //     userAccount.rainbowpassword
              // );

              if (isIOSDevice()) sendLoginToMobile(userAccount.rainbowusername, userAccount.rainbowpassword, agentid);
              else if (isAndroidDevice()) sendLoginToAndroid(userAccount.rainbowusername, userAccount.rainbowpassword, agentid);

              displayExtension = jsonMessage.Value.PhoneExtension;
              setBtnState(false);
              LoggedInAcdServer = 2;
              LoggedInAcdServerTime = new Date(messageQueue[0].detail.timestamp);
              setUserAccount({ ...userAccount, acdloggedin: true });
              setLoginResponse({ ...jsonMessage.Value });
              Current_AgentState = jsonMessage.Value.AgentStatus;
              setAgentState({ ...jsonMessage.Value.AgentStatus });
              setAbsenseReasons([...jsonMessage.Value.SettingsACD.AbsenseReasons]);
              // console.log(jsonMessage.Value);

              if (jsonMessage.Value.AgentStatus.AgentState == agentStatuses.Clerical_Work) CountDownTimer(jsonMessage.Value.AgentStatus.WrapUp_Remaining);

              var h_mesg = {
                Type: jsMessageType.HRT_BEAT,
                Value: '',
                CreationTime: '',
              };
              clearTimeout(timerId);
              timerId = setTimeout(function HRT_BEAT() {
                sendMsgToServer(myChannelObject, h_mesg);
                LastHeartBeatTime = new Date();
                timerId = setTimeout(HRT_BEAT, 30000); // (*)
              }, 30000);
            } else {
              // console.log("Login Failed");
              LoggedInAcdServer = 0;
              setUserAccount((userAccount) => ({
                ...userAccount,
                acdloggedin: false,
              }));
              setErrorMsg('Login Failed with error: ' + jsonMessage.Value.Error);
              setErrorOpen(true);
              setBtnState(false);
            }
          }

          if (jsonMessage.Type === jsMessageType.AGENT_STATE) {
            //console.log(loginResponse.PhoneExtension);
            let d = new Date(messageQueue[0].detail.timestamp);

            if (LoggedInAcdServer === 2 && LoggedInAcdServerTime - d < 0) {
              // console.log("Inside Agent State Logged In true If")
              if (
                Current_AgentState.AgentState !== jsonMessage.Value.AgentState ||
                Current_AgentState.RaiseHand !== jsonMessage.Value.RaiseHand ||
                Current_AgentState.Name !== jsonMessage.Value.Name ||
                Current_AgentState.OtherParty !== jsonMessage.Value.OtherParty ||
                Current_AgentState.LastGroupName !== jsonMessage.Value.LastGroupName ||
                Current_AgentState.LastGroupNumber !== jsonMessage.Value.LastGroupNumber
              ) {
                //console.log("INSIDE AGENT IF COMPARING PREVIOUS WITH NEW STATE");
                if (Current_AgentState.AgentState === agentStatuses.ACD_Busy && jsonMessage.Value.AgentState == agentStatuses.Clerical_Work) {
                  //setCallOutCome((callOutCome)=>({...callOutCome,myenable:true}));
                  outComeEnable = true;
                  //   console.log("My Enable Value After setting true: "+callOutCome.myenable);
                  let endTime = new Date();
                  currentCallDetail.EndTime = endTime.toLocaleString();
                  //setCallDetails ({...callDetails, EndTime:endTime.toLocaleTimeString()})
                }
                if (Current_AgentState.AgentState === agentStatuses.Clerical_Work && jsonMessage.Value.AgentState === agentStatuses.Idle) {
                  //console.log("OUTSIDE IF TO HIDE CALL REASONS AND SEND MESSAGE: "+callOutCome.myenable);
                  if (outComeEnable === true) {
                    //console.log("INSIDE IF TO HIDE CALL REASONS AND SEND MESSAGE");

                    //setCallOutCome({...callOutCome, myenable:false});
                    outComeEnable = false;
                    let mesg = {
                      Type: jsMessageType.SET_OUTCOME,
                      Value: {
                        AgentExtension: myExtension,
                        Name: Current_AgentState.Name,
                        StartTime: currentCallDetail.StartTime,
                        EndTime: currentCallDetail.EndTime,
                        CLI: currentCallDetail.CLI,
                        DDI: currentCallDetail.DDI,
                        PrimaryOutcome: primaryOC,
                        SecondaryOutcome: secondaryOC,
                        IsSuccess: false,
                      },
                      CreationTime: '',
                    };
                    sendMsgToServer(myChannelObject, mesg);
                  }
                }

                if (jsonMessage.Value.AgentState === agentStatuses.Temp_Absent || jsonMessage.Value.AgentState === agentStatuses.Not_Available) setCircularProgress(false);

                if (jsonMessage.Value.AgentState !== agentStatuses.Being_Routed) {
                  // window.Current_AgentState = Current_AgentState;
                  // console.log(
                  //   "Setting Agent State " + jsonMessage.Value.AgentState
                  // );
                  Current_AgentState = jsonMessage.Value;
                  setAgentState({ ...jsonMessage.Value });
                }

                if (jsonMessage.Value.AgentState === agentStatuses.Clerical_Work) {
                  CountDownTimer(jsonMessage.Value.WrapUp_Remaining);
                }
                if (jsonMessage.Value.AgentState === agentStatuses.Offline) {
                  // console.log("Agent State Zero Condition Fired");
                  LoggedInAcdServer = 0;
                  toggleEventListener(false);
                  rainbowSDK.channels.unsubscribeFromChannelById(myChannelID);
                  myChannelID = null;
                  clearTimeout(timerId);
                  if (isIOSDevice()) sendLogoutToMobile();
                  else if (isAndroidDevice()) sendLogoutToAndroid();

                  setUserAccount((userAccount) => ({
                    ...userAccount,
                    acdloggedin: null,
                  }));
                }
              }
            }
            //else console.log("Stale Message");
          }

          if (jsonMessage.Type == jsMessageType.VBOARD_STATS_CHANGED) {
            let d = new Date(messageQueue[0].detail.timestamp);
            if (LoggedInAcdServer == 2 && LoggedInAcdServerTime - d < 0) {
              // console.log("VBoard Stats Changed");
              setVBoardStats({ ...jsonMessage.Value });
            }
          }
          if (jsonMessage.Type == jsMessageType.GROUP_CALL_RINGING) {
            let d = new Date(messageQueue[0].detail.timestamp);
            if (LoggedInAcdServer == 2 && LoggedInAcdServerTime - d < 0) {
              // console.log("Group Call Ringing Message");
              setGroupCallRinging({ ...jsonMessage.Value });
            }
          }
          if (jsonMessage.Type == jsMessageType.GROUP_CALL_CONNECTED) {
            let d = new Date(messageQueue[0].detail.timestamp);
            if (LoggedInAcdServer == 2 && LoggedInAcdServerTime - d < 0) {
              let startTime = new Date();
              //console.log("Group Call Connected Message");
              currentCallDetail.CLI = jsonMessage.Value.CallerNumber;
              currentCallDetail.DDI = jsonMessage.Value.GroupNumber;
              currentCallDetail.StartTime = startTime.toLocaleString();
              setGroupCallRinging({ ...jsonMessage.Value });

              //if(Current_AgentState.AgentState==agentStatuses.Ringing_IN_ACD || Current_AgentState.AgentState==agentStatuses.Ringing_IN_ACD_Callback )
              //setAgentState(agentState => {return {...agentState, AgentState:agentStatuses.Custom_Connecting_ACD}})

              //setCallDetails({...callDetails, CLI:jsonMessage.Value.CallerNumber, DDI:jsonMessage.Value.LastGroupNumber,StartTime:d.toLocaleTimeString()})
            }
          }
          if (jsonMessage.Type == jsMessageType.GROUP_CALL_DISCONNECTED) {
            if (LoggedInAcdServer == 2 && LoggedInAcdServerTime - d < 0) {
              //setAgentState({...agentState,AgentState:agentStatuses.Available});
              setGroupCallRinging({ ...groupCallRinging, GroupName: '...' });
            }
          }

          if (jsonMessage.Type === jsMessageType.FORCED_LOGOUT) {
            signOut();
          }

          if (jsonMessage.Type === jsMessageType.LOGOUT_SUCCESS) {
            if (userAccount.acdloggedin == true) {
              clearTimeout(timerId);
              setUserAccount((userAccount) => ({
                ...userAccount,
                acdloggedin: null,
              }));

              if (isIOSDevice()) sendLogoutToMobile();
              else if (isAndroidDevice()) sendLogoutToAndroid();
            }
            // console.log("Successfully Logged Out");
            LoggedInAcdServer = 0;
            toggleEventListener(false);
            setBackdropOpen(false);
            rainbowSDK.channels.unsubscribeFromChannelById(myChannelID).then(() => {});
            myChannelID = null;
          }
          if (jsonMessage.Type === jsMessageType.HRT_BEAT) {
            hrtBeatReset = 0;
          }

          deleteMsgFromServer(messageQueue[0].detail.channelId, messageQueue[0].detail.id);
          messageQueue.shift();
          // console.log(
          //   "Queue Item Deleted. Items In Queue = " + messageQueue.length
          // );
        }
      } catch (err) {
        // console.log(err);
        break;
      }
    }
  }, []);

  const EndWrapUp = () => {
    if (LoggedInAcdServer == 2 && Current_AgentState.AgentState == agentStatuses.Clerical_Work) {
      let mesg = {
        Type: jsMessageType.END_WRAPUPTIME,
        Value: {
          Value: false,
          AgentExtension: Current_AgentState.AgentExtension,
          RemoteID: null,
        },
        CreationTime: '',
      };
      setAgentState({ ...agentState, AgentState: agentStatuses.Available });

      if (outComeEnable == true) outComeEnable = false;

      sendMsgToServer(myChannelObject, mesg);
      // console.log("Wrapup Message Sent");
    }
  };

  const RaiseHand = () => {
    // console.log("Send Raise Hand Message Called");
    if (LoggedInAcdServer == 2) {
      var mesg;
      if (raiseHand) {
        mesg = {
          Type: jsMessageType.SET_RAISEHAND,
          Value: {
            AgentExtension: Current_AgentState.AgentExtension,
            PhoneExtension: Current_AgentState.PhoneExtension,
            RaiseHand: false,
            IsAvailable: false,
            UnAvilabilityReason: '',
            AutoAnswer: false,
            IsLogin: false,
          },
          CreationTime: '',
        };
        setRaiseHand(false);
      } else {
        mesg = {
          Type: jsMessageType.SET_RAISEHAND,
          Value: {
            AgentExtension: Current_AgentState.AgentExtension,
            PhoneExtension: Current_AgentState.PhoneExtension,
            RaiseHand: true,
            IsAvailable: false,
            UnAvilabilityReason: '',
            AutoAnswer: false,
            IsLogin: false,
          },
          CreationTime: '',
        };
        setRaiseHand(true);
      }

      sendMsgToServer(myChannelObject, mesg);
    }
  };
  const sendAgentGroupsMsg = (Groups) => {
    // console.log("sendagentgroups function");
    //var Groups = JSON.stringify(groups);
    var mesg = {
      Type: jsMessageType.SET_AGENT_QUEUES_AVAILABILITY,
      Value: {
        Groups,
        AgentExtension: Current_AgentState.AgentExtension,
        RemoteID: null,
      },
      CreationTime: '',
    };
    sendMsgToServer(myChannelObject, mesg);
    //console.log(JSON.stringify(mesg));
  };

  const sendUnavailableMsg = (status) => {
    //console.log('sendaUnavailable function');
    //console.log(status);
    //var Groups = JSON.stringify(groups);
    var mesg;
    if (status != '') {
      mesg = {
        Type: jsMessageType.SET_AVAILABILITY,
        Value: {
          AgentExtension: Current_AgentState.AgentExtension,
          PhoneExtension: Current_AgentState.PhoneExtension,
          RaiseHand: false,
          IsAvailable: false,
          UnAvailibilityReason: status,
          AutoAnswer: false,
          IsLogin: false,
        },
        CreationTime: '',
      };
    } else {
      mesg = {
        Type: jsMessageType.SET_AVAILABILITY,
        Value: {
          AgentExtension: Current_AgentState.AgentExtension,
          PhoneExtension: Current_AgentState.PhoneExtension,
          RaiseHand: false,
          IsAvailable: true,
          UnAvailibilityReason: '',
          AutoAnswer: false,
          IsLogin: false,
        },
        CreationTime: '',
      };
    }
    sendMsgToServer(myChannelObject, mesg);
    //console.log(JSON.stringify(mesg));
  };

  const CountDownTimer = (counter) => {
    var lbl = counter;
    //console.log("Counter Value"+ counter);
    var x = setInterval(function () {
      if (counter < 10) lbl = '0' + counter;
      else lbl = counter;

      setCountDown(lbl);
      counter--;
      if (counter < 0) clearInterval(x);
    }, 1000);
  };

  //////////////////////////////////////////////////////////////////////////////////////////////
  /////////////////////////////////// END COMPONENT LOGIC///////////////////////////////////////

  //////////////////////////////////////////////////////////////////////////////////////////////
  /////////////////////////////////// START UI LOGIC FUNCTIONS//////////////////////////////////

  function Alert(props) {
    return <MuiAlert elevation={6} variant='filled' {...props} />;
  }

  const handleErrorClose = (event, reason) => {
    if (reason === 'clickaway') {
      return;
    }
    setErrorOpen(false);
  };

  const handleClickOpenQueue = () => {
    //console.log("Open Dialog Function");
    setAgentGroups([...Current_AgentState.AssociatedGroups]);
    setOpenQueueDialog(true);
  };

  const handleCloseQueue = (value) => {
    // console.log("Close Dialog Function");
    //console.log(value);
    if (value != null) {
      setAgentGroups([...value]);
      sendAgentGroupsMsg(value);
    }
    setOpenQueueDialog(false);
  };

  const handleClickOpenUnavailable = () => {
    // console.log("Handle Open Unavailble Fired");
    if (Current_AgentState.IsAvailable) setOpenUnavailableDialog(true);
    else {
      setAgentState({ ...agentState, AgentState: agentStatuses.Available });
      //noSleep.enable();
      sendUnavailableMsg('');
    }
  };

  const handleCloseUnavailable = (value) => {
    // console.log("Handle Close Unavailable Fire");
    if (value != null && value != '') {
      setCircularProgress(true);
      // console.log("sent unavailable message");
      //noSleep.disable();
      sendUnavailableMsg(value);
      //setAgentState({...agentState,AgentState:agentStatuses.Temp_Absent});
    }

    setOpenUnavailableDialog(false);
  };

  const handleChangeOutCome = (value) => {
    //console.log("RETURNED OUTCOME TO VURELLA_ACD IS: "+value.primaryOutCome+"-:-"+value.secondaryOutCome);
    setCallOutCome({ ...callOutCome, ...value });
  };
  const hangupCall = () => {
    //props.updateAgentState({...props.state, AgentState:agentStatuses.Custom_HangingUp})
    setAgentState((agentState) => {
      return { ...agentState, AgentState: agentStatuses.Custom_HangingUp };
    });
    rainbowSDK.telephony.release(callID).then(() => {});
  };

  /////////////////////////////////// //END UI LOGIC///////////////////////////////////////////
  //////////////////////////////////////////////////////////////////////////////////////////////
  useEffect(() => {
    //console.log("Call OutCome UseEffect Fired");
    primaryOC = callOutCome.primaryOutCome;
    secondaryOC = callOutCome.secondaryOutCome;
  }, [callOutCome]);

  const toggleEventListener = useCallback((value) => {
    if (value == true) {
      // console.log("Add Listener Called");
      document.addEventListener(rainbowSDK.channels.RAINBOW_ONCHANNELMESSAGERECEIVED, onChannelMessageReceived);
      document.addEventListener(rainbowSDK.connection.RAINBOW_ONCONNECTIONSTATECHANGED, onConnectionStateChanged);
      document.addEventListener(rainbowSDK.telephony.RAINBOW_ONTELEPHONYCALLSTATECHANGED, onTelephonyChangedEvent);
      document.addEventListener(rainbowSDK.telephony.RAINBOW_ONVOIPCALLSTATECHANGED, onTelephonyVoipChangedEvent);
    } else {
      // console.log("Remove Listener Called");
      document.removeEventListener(rainbowSDK.channels.RAINBOW_ONCHANNELMESSAGERECEIVED, onChannelMessageReceived);
      document.removeEventListener(rainbowSDK.connection.RAINBOW_ONCONNECTIONSTATECHANGED, onConnectionStateChanged);
      document.removeEventListener(rainbowSDK.telephony.RAINBOW_ONTELEPHONYCALLSTATECHANGED, onTelephonyChangedEvent);
      document.removeEventListener(rainbowSDK.telephony.RAINBOW_ONVOIPCALLSTATECHANGED, onTelephonyVoipChangedEvent);
    }
  }, []);
  ////////////////////////////////////ACD LOGIN FUNCTIONS//////////////////////////////////
  var agentid = '';

  const handleSubmit = useCallback((event) => {
    event.preventDefault();
    window.rainbowSDK = rainbowSDK;
    if (rainbowSDK.connection.getState() == 'connected') {
      toggleEventListener(true);
      setBtnState(true);
      agentid = event.target.elements.agentid.value;
      let pass = event.target.elements.password.value;
      setUserName(agentid);
      setPassWord(pass);
      //console.log(myExt);
      //myExtension = rainbowSDK.contacts.getConnectedUser().phoneInternalNumber;
      if (agentExt == null) {
        agentExt = myExt;
      }
      if (agentExt == 'other') {
        let physicalExt = event.target.elements.physicalextension.value ?? '';
        if (physicalExt != '' && physicalExt != null) {
          myExtension = physicalExt;
          setOtherExt(physicalExt);
          localStorage.setItem('otherext', physicalExt);
        }
      } else myExtension = agentExt;

      if (agentExt == 'nomadic') {
        rainbowSDK.telephony.setNomadicVoIP();
      }

      setUserAccount((userAccount) => ({ ...userAccount, acdloggedin: false }));
      localStorage.setItem('agentid', agentid);
      localStorage.setItem('agentpassword', pass);
      loginVACD(agentid, pass);
      //console.log(agentExt);
      // console.log("LOGIN ACD CALLED");
    } else {
      setErrorMsg('Error Logging In... Rainbow Disconnected');
      setErrorOpen(true);
    }
  }, []);
  const handleExtensionChange = (event) => {
    if (event.target.value == 'other') setShowExtTB(true);
    else setShowExtTB(false);

    agentExt = event.target.value;
    setMyExtension(event.target.value);
    localStorage.setItem('myExt', event.target.value);
  };

  return (
    <React.Fragment>
      {!userAccount.acdloggedin && (
        <div className={classes.loginACD}>
          <Paper className={classes.Loginpaper} elevation={0}>
            <form onSubmit={handleSubmit}>
              <Grid>
                <Grid item>
                  <img alt='vurellaacd' src={vurellaACD} />
                </Grid>
                <Grid item style={{ paddingBottom: '15px' }}>
                  <Typography variant='h5' style={{ color: '#0288d1' }}>
                    {t('agentlogin.agentlogin')}
                  </Typography>
                </Grid>
                <Grid item>
                  <TextField id='agentid' label={t('agentlogin.agentid')} variant='outlined' defaultValue={userN} required />
                </Grid>
                <Grid item>
                  <TextField id='password' label={t('agentlogin.password')} type='password' variant='outlined' defaultValue={passW} required />
                </Grid>
                <Grid item>
                  <TextField
                    id='extensionselect'
                    select
                    label={t('agentlogin.extension')}
                    value={myExt}
                    onChange={handleExtensionChange}
                    variant='outlined'
                    style={{ width: '310px', textAlign: 'left' }}>
                    <MenuItem value='office'>My Office Phone</MenuItem>
                    <MenuItem value='nomadic'>My Nomadic Extension</MenuItem>
                    <MenuItem value='other'>Another Extension</MenuItem>
                  </TextField>
                </Grid>
                {showExtTB && (
                  <Grid item>
                    <TextField id='physicalextension' label='Extension' variant='outlined' />
                  </Grid>
                )}
                <Grid item style={{ marginTop: '12px' }}>
                  <Button disabled={btnState} variant='contained' color='primary' type='submit' startIcon={<PersonIcon />}>
                    {t('agentlogin.loginbtn')} {btnState && <CircularProgress size={24} className={classes.buttonProgress} />}
                  </Button>
                </Grid>
              </Grid>
            </form>
          </Paper>
          <div
            style={{
              position: 'fixed',
              left: 0,
              bottom: 30,
              width: '100%',
              textAlign: 'center',
            }}>
            <img
              alt='vurellalogo'
              onClick={() => {
                signOutRainbow();
              }}
              style={{ cursor: 'pointer' }}
              src={vurellaLogo}
              width='115'
              height='40'
            />
          </div>
        </div>
      )}
      {userAccount.acdloggedin && (
        <div className={classes.container}>
          <Grid item xs={12} style={{ textAlign: 'center' }}>
            <img src={vurellaLogo} width='115' height='40' />
          </Grid>
          {/* <div
            style={{
              position: "fixed",
              top: 10,
              left: 0,
              width: "100%",
              textAlign: "center",
            }}
          >
          </div> */}
          <Grid container spacing={2} className={classes.root}>
            <Grid item xs={12}>
              {!outComeEnable && (
                <AgentStateCard circularProgressState={circularProgress} state={agentState} groupCR={groupCallRinging} displayExtension={displayExtension} updateAgentState={setAgentState} />
              )}
              {outComeEnable && <SetOutComes outComeData={loginResponse} onChange={handleChangeOutCome} />}
            </Grid>
            <Grid item xs={12}>
              {agentState.AgentState != agentStatuses.ACD_Busy && agentState.AgentState != agentStatuses.Non_Acd_Busy && agentState.AgentState != agentStatuses.ACD_Busy_Callback && (
                <Card
                  className={classes.Card_RH}
                  disabled={agentState.AgentState == agentStatuses.Clerical_Work ? false : true}
                  style={{
                    backgroundColor: agentState.AgentState == agentStatuses.Clerical_Work ? '#0288d1' : '#d3d3d3',
                    cursor: agentState.AgentState == agentStatuses.Clerical_Work ? 'pointer' : 'default',
                  }}>
                  <CardContent
                    onClick={() => {
                      EndWrapUp();
                    }}>
                    <IconButton aria-label='end-wrapup' style={{ color: 'white' }} disabled={agentState.AgentState == agentStatuses.Clerical_Work ? false : true}>
                      <TimerIcon />{' '}
                      {(agentState.AgentState == agentStatuses.Clerical_Work && (
                        <Typography variant='body2' style={{ color: 'white' }}>
                          {' '}
                          {'  00:' + countDown}
                        </Typography>
                      )) ||
                        (agentState.AgentState != agentStatuses.Clerical_Work && (
                          <Typography variant='body2' style={{ color: 'white' }}>
                            {' '}
                            {'  --:--'}
                          </Typography>
                        ))}
                    </IconButton>
                    <Typography variant='body2' style={{ color: 'white' }}>
                      {t('app.endwrapup')}
                    </Typography>
                  </CardContent>
                </Card>
              )}
              {(agentState.AgentState == agentStatuses.ACD_Busy || agentState.AgentState == agentStatuses.Non_Acd_Busy || agentState.AgentState == agentStatuses.ACD_Busy_Callback) && (
                <Card
                  style={{
                    backgroundColor: 'red',
                    justifyContent: 'center',
                    textAlign: 'center',
                  }}>
                  <CardContent
                    onClick={() => {
                      hangupCall();
                    }}>
                    <IconButton aria-label='raise-hand' style={{ color: raiseHand ? 'red' : 'white' }}>
                      <CallEndIcon style={{ color: 'white' }} fontSize='large' />
                    </IconButton>
                    <Typography variant='body2' style={{ color: 'white' }}>
                      {t('app.hangup')}
                    </Typography>
                  </CardContent>
                </Card>
              )}
            </Grid>
            <Grid item xs={12} style={{ padding: '0px 8px' }}>
              <Grid container justify='center' spacing='1'>
                <Grid item xs={6}>
                  <Card className={classes.Card_RH}>
                    <CardContent
                      onClick={() => {
                        RaiseHand();
                      }}>
                      <IconButton aria-label='raise-hand' style={{ color: raiseHand ? 'red' : 'white' }}>
                        <HandIcon />
                      </IconButton>
                      <Typography variant='body2' style={{ color: 'white' }}>
                        {t('app.raisehand')}
                      </Typography>
                    </CardContent>
                  </Card>
                </Grid>
                <Grid item xs={6}>
                  <Card className={classes.Card_Queues}>
                    <CardContent
                      onClick={() => {
                        handleClickOpenQueue();
                      }}>
                      <IconButton aria-label='manage-queues' style={{ color: 'white' }}>
                        <QueueIcon />
                      </IconButton>
                      <Typography variant='body2' style={{ color: 'white' }}>
                        {t('app.queues')}
                      </Typography>
                    </CardContent>
                    <QueuesDialog state={agentGroups} open={openQueueDialog} onClose={handleCloseQueue} />
                  </Card>
                </Grid>
              </Grid>
            </Grid>
            <Grid item xs={12}>
              <Grid container justify='center' spacing='1'>
                <Grid item xs={6}>
                  <Card
                    raised={false}
                    onClick={() => {
                      handleClickOpenUnavailable();
                    }}
                    className={classes.Card_RH_2}
                    disabled={
                      agentState.AgentState == agentStatuses.ACD_Busy ||
                      agentState.AgentState == agentStatuses.Non_Acd_Busy ||
                      agentState.AgentState == agentStatuses.Ringing_IN_ACD ||
                      agentState.AgentState == agentStatuses.Ringing_IN_ACD_Callback ||
                      agentState.AgentState == agentStatuses.Non_Acd_Ringing
                        ? true
                        : false
                    }
                    style={{
                      backgroundColor:
                        agentState.AgentState == agentStatuses.ACD_Busy ||
                        agentState.AgentState == agentStatuses.Non_Acd_Busy ||
                        agentState.AgentState == agentStatuses.Ringing_IN_ACD ||
                        agentState.AgentState == agentStatuses.Ringing_IN_ACD_Callback ||
                        agentState.AgentState == agentStatuses.Non_Acd_Ringing
                          ? '#d3d3d3'
                          : '#0288d1',
                      cursor:
                        agentState.AgentState == agentStatuses.ACD_Busy ||
                        agentState.AgentState == agentStatuses.Non_Acd_Busy ||
                        agentState.AgentState == agentStatuses.Ringing_IN_ACD ||
                        agentState.AgentState == agentStatuses.Ringing_IN_ACD_Callback ||
                        agentState.AgentState == agentStatuses.Non_Acd_Ringing
                          ? 'default'
                          : 'pointer',
                    }}>
                    <CardContent>
                      <IconButton aria-label='un-available' style={{ color: 'white' }}>
                        <UnavailableIcon />
                      </IconButton>
                      <Typography variant='body2' style={{ color: 'white' }}>
                        {Current_AgentState.IsAvailable ? t('app.unavailable') : t('app.available')}
                      </Typography>
                    </CardContent>
                  </Card>
                </Grid>
                <Grid item xs={6}>
                  <Card
                    raised={false}
                    onClick={() => {
                      signOut();
                    }}
                    className={classes.Card_RH_2}
                    disabled={
                      agentState.AgentState == agentStatuses.ACD_Busy ||
                      agentState.AgentState == agentStatuses.Non_Acd_Busy ||
                      agentState.AgentState == agentStatuses.Ringing_IN_ACD ||
                      agentState.AgentState == agentStatuses.Ringing_IN_ACD_Callback ||
                      agentState.AgentState == agentStatuses.Non_Acd_Ringing
                        ? true
                        : false
                    }
                    style={{
                      backgroundColor:
                        agentState.AgentState == agentStatuses.ACD_Busy ||
                        agentState.AgentState == agentStatuses.Non_Acd_Busy ||
                        agentState.AgentState == agentStatuses.Ringing_IN_ACD ||
                        agentState.AgentState == agentStatuses.Ringing_IN_ACD_Callback ||
                        agentState.AgentState == agentStatuses.Non_Acd_Ringing
                          ? '#d3d3d3'
                          : '#0288d1',
                      cursor:
                        agentState.AgentState == agentStatuses.ACD_Busy ||
                        agentState.AgentState == agentStatuses.Non_Acd_Busy ||
                        agentState.AgentState == agentStatuses.Ringing_IN_ACD ||
                        agentState.AgentState == agentStatuses.Ringing_IN_ACD_Callback ||
                        agentState.AgentState == agentStatuses.Non_Acd_Ringing
                          ? 'default'
                          : 'pointer',
                    }}>
                    <CardContent>
                      <IconButton aria-label='sign-out' style={{ color: 'white' }}>
                        <SignOutIcon />
                      </IconButton>
                      <Typography variant='body2' style={{ color: 'white' }}>
                        {t('app.logout')}
                      </Typography>
                    </CardContent>
                  </Card>
                </Grid>
              </Grid>
              <UnavailableDialog settings={absenseReasons} open={openUnavailableDialog} onClose={handleCloseUnavailable} />
            </Grid>
            {loginResponse.IsAgentWallboardLicensed ? <VBoard vboardStats={vboardStats} agentGroups={Current_AgentState.AssociatedGroups} /> : ''}
          </Grid>
        </div>
      )}
      <Snackbar open={errorOpen} autoHideDuration={8000} onClose={handleErrorClose}>
        <Alert onClose={handleErrorClose} severity='error'>
          {errorMsg}
        </Alert>
      </Snackbar>
      <Backdrop className={classes.backdrop} open={backdropOpen} onClick={handleReconnectClose}>
        <CircularProgress color='inherit' />
      </Backdrop>
    </React.Fragment>
  );
}
